import * as types from "./types";

const initialState = {
  activeNotifications: [],
  loading: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ACTIVE_NOTIFICATIONS_REQUEST:
    case types.CREATE_NOTIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_ACTIVE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        activeNotifications: action.payload,
      };

    case types.CREATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeNotifications: [
          ...state.activeNotifications,
          action.payload,
        ],
      };

    case types.GET_ACTIVE_NOTIFICATIONS_FAILURE:
    case types.CREATE_NOTIFICATION_FAILURE:
    case types.UPDATE_NOTIFICATION_FAILURE:
    case types.ENABLE_NOTIFICATION_FAILURE:
    case types.DISABLE_NOTIFICATION_FAILURE:
    case types.DELETE_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}